import { Component, inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { ReportDetailsComponent } from '../../../scouting/screens/report-details/report-details.component';
import { RouterModule } from '@angular/router';
import { PlayerListViewModel } from '../../../shared/models/player.model';
import { MatDivider, MatDividerModule } from "@angular/material/divider";
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipListbox, MatChipsModule } from '@angular/material/chips';
import { GameHeaderFullComponent } from '../../components/game-header-full/game-header-full.component';
import { GameHeaderSmallComponent } from '../../../scouting/components/game-header-small/game-header-small.component';
import { GameService } from '../../../shared/services/game.service';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-set-grades-dialog',
  imports: [MatDialogModule, MatButtonModule, RouterModule, MatDividerModule, MatButtonToggleModule, MatChipsModule,
      GameHeaderSmallComponent, CommonModule, MatProgressSpinnerModule],
  templateUrl: './set-grades-dialog.component.html',
  styleUrl: './set-grades-dialog.component.css',
})
export class SetGradesDialogComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<SetGradesDialogComponent>);
  readonly data = inject(MAT_DIALOG_DATA);
  readonly gameService = inject(GameService);
  readonly cdr = inject(ChangeDetectorRef);
  players: PlayerListViewModel[] = [];
  game: any;
  team: 'home' | 'away' = 'home';
  playerGrades: Map<string, number> = new Map();
  isLoadingGrades = true;


  ngOnInit() {
    this.players = this.resolveValue(this.data?.players, [] as PlayerListViewModel[]);
    this.game = this.resolveValue(this.data?.game, null);
    this.team = this.resolveValue(this.data?.team, 'home');
    // console.log('SetGradesDialog: Initialized with data', this.data);
    // console.log('SetGradesDialog: Grading team:', this.team);
    
    // Load existing grades for this game
    if (this.game?.GameId) {
      // console.log('SetGradesDialog: Loading grades for GameId', this.game.GameId);
      this.loadExistingGrades(this.game.GameId);
    } else {
      // console.warn('SetGradesDialog: No GameId found, skipping grade loading');
      this.isLoadingGrades = false;
    }
  }

  private loadExistingGrades(gameId: string): void {
    this.gameService.getGradesPerGameForUser(gameId).subscribe({
      next: (gradesData) => {
        // console.log('SetGradesDialog: Raw grades data received');
        
        // Process all scouts' rankings
        if (gradesData?.PlayerRankings && gradesData.PlayerRankings.length > 0) {
          gradesData.PlayerRankings.forEach((rankings) => {
            // Process home team rankings
            if (rankings.GamePlayerRankingsHome && rankings.GamePlayerRankingsHome.length > 0) {
              rankings.GamePlayerRankingsHome.forEach(ranking => {
                if (ranking.PlayerId && ranking.Ranking !== undefined && ranking.Ranking !== null) {
                  this.playerGrades.set(ranking.PlayerId, ranking.Ranking);
                }
              });
            }
            
            // Process away team rankings
            if (rankings.GamePlayerRankingsAway && rankings.GamePlayerRankingsAway.length > 0) {
              rankings.GamePlayerRankingsAway.forEach(ranking => {
                if (ranking.PlayerId && ranking.Ranking !== undefined && ranking.Ranking !== null) {
                  this.playerGrades.set(ranking.PlayerId, ranking.Ranking);
                }
              });
            }
          });
        } else {
          // console.warn('SetGradesDialog: No PlayerRankings data found');
        }
        
        // console.log(`SetGradesDialog: Total grades loaded: ${this.playerGrades.size}`);
        // console.log('SetGradesDialog: All grades in Map:', Array.from(this.playerGrades.entries()));
        this.isLoadingGrades = false;
        this.cdr.detectChanges(); // Force change detection
      },
      error: (error) => {
        // console.error('SetGradesDialog: Error loading grades', error);
        this.isLoadingGrades = false;
        this.cdr.markForCheck();
      }
    });
  }

  getPlayerGrade(playerId: string): string {
    const grade = this.playerGrades.get(playerId) || 0;
    return grade.toString();
  }

  private resolveValue<T>(value: unknown, fallback: T): T {
    try {
      const resolved = typeof value === 'function' ? (value as () => unknown)() : value;
      return (resolved ?? fallback) as T;
    } catch {
      return fallback;
    }
  }

  
  getGoalies(){
    return this.players.filter(function (el){
      return el.PlayerView.PositionId==1;
    });
  }

  getDefenders(){
    return this.players.filter(function (el){
      return el.PlayerView.PositionId==2 || el.PlayerView.PositionId==3;
    });
  }

  getForwards(){
    return this.players.filter(function (el){
      return el.PlayerView.PositionId>3;
    });
  }

  UpdateGamePlayerRating(PlayerId: string, GameId: string, Rating: string){
      const ratingNum = parseInt(Rating);
      const teamId = this.team === 'home' ? this.game.TeamHomeId : this.game.TeamAwayId;
      // console.log(`SetGradesDialog: Updating grade for player ${PlayerId} to ${ratingNum}, team: ${this.team}, teamId: ${teamId}`);
      
      this.gameService.updateGameGrade(GameId, ratingNum, teamId, PlayerId).subscribe({
        next: (data) => {
          // console.log('SetGradesDialog: Grade updated successfully', data);
          // Update local cache
          this.playerGrades.set(PlayerId, ratingNum);
        },
        error: (error) => {
          // console.error('SetGradesDialog: Error updating grade', error);
        }
      });
  }
  
}
